module.exports = __webpack_public_path__ + "static/fonts/BMYEONSUNG.9396b32.woff";